<template>
  <header>
    <div class="container">
      <nav>
        <div class="logo-container" @click="$router.push('/')" style="cursor: pointer;">
          <img src="logo.png" alt="InboxMaster Logo">
          <div class="logo-text">inboxmaster.ai</div>
        </div>
        <div class="nav-links">
            <slot />
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "AppNavbar"
});
</script>

<style scoped>
header {
  background-color: rgba(255, 255, 255, 0.5);
  padding: 20px 40px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}
.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
}
nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logo-container {
  display: flex;
  align-items: center;
}
.logo-container img {
  height: 40px;
  margin-right: 10px;
}
.logo-text {
  font-size: 24px;
  font-weight: 100;
  color: black;
}
.nav-links {
  display: flex;
  align-items: center;
  gap: 12px;
}
@media (max-width: 768px) {
  header {
    position: static;
    background-color: rgba(255, 255, 255, 1);
    padding: 15px 20px;
  }
  
  nav {
    flex-direction: column;
    gap: 15px;
  }
  
  .nav-links {
    margin-top: 0;
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }
}
</style> 